window.mainData = () => {
  return {
    dropdownMenu: false,
    modalMenu: false,
    modalMenuProducts: false,
    modalMenuProductsCat1: false,
    modalMenuProductsCat2: false,
    modalMenuProductsCat3: false,
    modalMenuProductsCat4: false,
    activeMenuTab : '2',
    searchOpen: false,
    noScroll: false,
    setMargin() {
      let header = document.getElementById('header');

      const myObserver = new ResizeObserver(entries => {
          let menu = document.querySelector('#menu');
          let menuProducts = document.querySelector('#menuProducts');
          let menuSmallCategories = document.querySelectorAll('.menu-categories-small')
          
          
          entries.forEach(entry => {
              
              let h = entry.contentRect.height;

              if (h > 0) {
                  menu.style.marginTop = `${h}px`;
                  menu.style.paddingBottom = `${h}px`;
                  menuProducts.style.marginTop = `${h}px`;
                  menuProducts.style.paddingBottom = `${h}px`;

                  menuSmallCategories.forEach(item => {
                    item.style.marginTop = `${h}px`;
                    item.style.paddingBottom = `${h}px`;
                  })
              }
          });
        });
          myObserver.observe(header);
    } 
  };
}
